// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MDZAV","col":"styles_col__21-Sa"};